<template>
  <b-overlay :show="formShow" rounded="true" :fixed="true" no-fade>
    <b-card>


      <!-- Filters Section -->
      <div class="mb-3 ">
        <b-row class="w-100">
          <b-col cols="12" lg="4">
            <b-form-group label-class="text-left">
              <v-select 
                id="event" 
                v-model="selectedEvent" 
                :options="eventTypes" 
                :reduce="(val) => val" 
                :filterable="true" 
                placeholder="Search by event" 
                @option:selected="selectedEvents" 
                label="title" 
                :clearable="false" 
                input-id="event" 
              />
            </b-form-group>
          </b-col>

          <b-col cols="12" lg="4">
            <b-form-group label-class="text-left">
              <b-input-group>
                <flat-pickr 
                  :disabled="resultData.tableData && resultData.tableData.length === 0" 
                  placeholder="Select Date Range" 
                  v-model="rangeDate" 
                  onClose="testClose" 
                  class="form-control" 
                  :config="datePickerConfig" 
                />
                <b-input-group-append>
                  <b-button @click="clearDate()" variant="warning">Clear</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col cols="12" lg="2">
            <b-form-group label-class="text-left">
              <b-button 
                @click="showArchiveRecords()" 
                variant="warning" 
                block
              >
                {{ archive == 'N' ? 'Include Archived' : 'Hide Archived' }}
              </b-button>
            </b-form-group>
          </b-col>

          <b-col cols="12" lg="2">
            <b-form-group label-class="text-left">
              <b-button 
                block
                class="ml-2" 
                variant="success" 
                @click="downloadPdf()" 
                :disabled="!resultData.tableData || resultData.tableData.length === 0"
              >
                Download PDF
              </b-button>
   
            </b-form-group>
          </b-col>
        </b-row>
        <!-- Shortcut Buttons Row -->
        <b-row class="w-100 mt-1">
          <b-col cols="12" class="d-flex flex-row flex-wrap">
            <b-button size="sm" class="mr-1 mb-50" variant="info" @click="selectThisWeek">This Week</b-button>
            <b-button size="sm" class="mr-1 mb-50" variant="info" @click="selectThisMonth">This Month</b-button>
            <b-button size="sm" class="mr-1 mb-50" variant="info" @click="selectLastMonth">Last Month</b-button>
            <b-button size="sm" class="mr-1 mb-50" variant="info" @click="selectNextMonth">Next Month</b-button>
            <b-button size="sm" class="mr-1 mb-50" variant="info" @click="selectThisYear">This Year</b-button>
          </b-col>
        </b-row>
      </div>

      <!-- Main Content Row -->
      <b-row class="mt-3">
        <!-- Left Column - Chart -->
        <b-col cols="12" xl="9" lg="9" md="12" sm="12">
          <b-card>
            <b-card-header class="pb-0">
            </b-card-header>
            <b-card-body class="pt-2" v-if="chartData.labels.length > 0">
              <chartjs-component-bar-chart 
                ref="observerChart"
                :height="400" 
                :data="chartData" 
                :refreshChart="refreshChart" 
                :options="chartDataOptions" 
                :lineLabel="'Company Average'"
              />
              
            </b-card-body>
            <b-card-body v-else class="pt-2">
              <div class="text-center text-muted py-5">
                <p>No data available for the selected criteria</p>
              </div>
            </b-card-body>
          </b-card>
        </b-col>

        <!-- Right Column - Statistics -->
        <b-col cols="12" xl="3" lg="3" md="12" sm="12">
          <b-card>
            <b-card-header class="pb-0">
            </b-card-header>
            <b-card-body class="pt-2">
              <table class="table table-bordered table-sm statistics-table">
                <tbody class="text-center">
                  <tr>
                    <th class="bg-dark text-white">
                      Total Company Score
                    </th>
                  </tr>
                  <tr>
                    <td class="bg-light-secondary font-weight-bold">
                      {{ resultData.statistics ? resultData.statistics.totalCompanyScore : 'N/A' }}
                    </td>
                  </tr>

                  <tr>
                    <th class="bg-dark text-white">
                      Company Benchmark
                    </th>
                  </tr>
                  <tr>
                    <td class="bg-light-secondary font-weight-bold">
                      {{ resultData.statistics ? resultData.statistics.companyBenchmark : 'N/A' }}
                    </td>
                  </tr>

                  <tr>
                    <th class="bg-dark text-white">Mean/Average Score</th>
                  </tr>
                  <tr>
                    <td class="bg-light-secondary font-weight-bold">
                      <b style="color:red">{{ resultData.statistics ? resultData.statistics.meanScore : 'N/A' }}</b>
                    </td>
                  </tr>

                  <tr>
                    <th class="bg-dark text-white">Standard Deviation</th>
                  </tr>
                  <tr>
                    <td class="bg-light-secondary font-weight-bold">
                      {{ resultData.statistics ? resultData.statistics.standardDeviation : 'N/A' }}
                    </td>
                  </tr>

                  <tr>
                    <th class="bg-dark text-white">Total Number of Reviews</th>
                  </tr>
                  <tr>
                    <td class="bg-light-secondary font-weight-bold">
                      {{ resultData.statistics ? resultData.statistics.totalNumberOfSurveys : 'N/A' }}
                    </td>
                  </tr>

                  <tr>
                    <th class="bg-dark text-white">
                      Reviewers Above Average
                    </th>
                  </tr>
                  <tr>
                    <td class="bg-light-secondary bg-success font-weight-bold">
                      {{ resultData.statistics ? resultData.statistics.reviewersAboveAverage : 0 }}
                    </td>
                  </tr>

                  <tr>
                    <th class="bg-dark text-white">Reviewers Below Average</th>
                  </tr>
                  <tr>
                    <td class="bg-light-secondary bg-warning font-weight-bold">
                      {{ resultData.statistics ? resultData.statistics.reviewersBelowAverage : 0 }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>

        <b-row>
        <b-col>
          <div class="d-flex justify-content-end mb-2">
            <b-button variant="success" 
            @click="downloadExcel()"
                :disabled="!selectedEvent || !resultData.tableData || resultData.tableData.length === 0 || download"
              >Export .xlsx</b-button
            >
          </div>
        </b-col>
      </b-row>

      <!-- Observer Data Table -->
      <b-row class="mt-4" v-if="resultData.tableData && resultData.tableData.length > 0">
        <b-col cols="12">
          <b-card>
            <b-card-header class="pb-0">
            </b-card-header>
            <b-card-body class="pt-2">
              <div class="table-responsive">
                <table class="table table-bordered table-striped observer-stats-table">
                  <thead class="thead-dark">
                    <tr>
                      <th class="text-center">Reviewer Name</th>
                      <th class="text-center"># test</th>
                      <th class="text-center">Avg Per Test</th>
                      <th v-for="groupName in resultData.groupNames" :key="groupName" class="text-center">{{ groupName }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="observer in resultData.tableData" :key="observer.observer">
                      <td class="font-weight-bold">{{ observer.observer }}</td>
                      <td class="text-center">{{ observer.testCount }}</td>
                      <td class="text-center">{{ observer.avgPerTest }}</td>
                      <td v-for="groupName in resultData.groupNames" :key="groupName" class="text-center">
                        {{ observer[groupName] !== undefined ? observer[groupName] : 'N/A' }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-card>

    <template #overlay v-if="download">
      <div class="text-center">
        <p id="cancel-label"><feather-icon icon="DownloadIcon" /> Report creating please wait...</p>
      </div>
    </template>
  </b-overlay>
</template>

<script>
import { BCol, BRow, BTab, BTabs, BCard, BAlert, BLink, VBModal, VBTooltip, BTooltip } from 'bootstrap-vue';
import { ref, onUnmounted } from '@vue/composition-api';
import ChartjsComponentBarChart from './charts-components/ChartjsComponentBarChart.vue';

import store from '@/store';
import reportStoreModule from '../reportStoreModule';
import ImageCropper from '@core/components/image-cropper/ImageCropper.vue';
import { required, alphaNum, email } from '@validations';
import Ripple from 'vue-ripple-directive';
import vSelect from 'vue-select';
import Cleave from 'vue-cleave-component';
import 'cleave.js/dist/addons/cleave-phone.us';
import router from '@/router';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import axiosIns from '@/libs/axios';
import _ from 'lodash';
import { t } from '@/@core/libs/i18n/utils';
import { backgroundColor } from 'echarts/lib/theme/dark';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import { $themeColors } from '@themeConfig';

export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,
    BRow,
    BCol,
    BTooltip,

    vSelect,
    Cleave,
    ToastificationContent,
    ImageCropper,
    ValidationProvider,
    ValidationObserver,
    flatPickr,

    ChartjsComponentBarChart,
  },

  directives: {
    Ripple,
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
  },



  props: ['StatTrigger','selectedSites'],

  data: function() {
    return {
      resultData: {
        tableData: [],
        chartData: [],
        statistics: null,
        groupNames: [],
        chartColour: '#84D0FF',
        surveyTitle: ''
      },
      archive: 'N',
      rangeDate: null,
      filterDateStart: null,
      filterDateEnd: null,
      baseURL: store.state.app.baseURL,
      required,
      alphaNum,
      email,
      dropdownLoading: false,
      download: false,
      formShow: false,
      schools: [],
      selectedSchool: null,
      groups: [],
      allGroupsData: [],
      filteredQuestions: [],
      selectedEvent: null,
      ans: null,
      summaryList: null,
      answerTypes: [1, 2, 3, 4, 'Not Observed'],
      eventTypes: [],
      refreshChart: false,
      datePickerConfig: {
        mode: 'range',
        dateFormat: 'd/m/Y',
        locale: { firstDayOfWeek: 1 },
        onChange: (selectedDates) => {
          if (selectedDates && selectedDates.length === 2) {
            this.applySelectedDates(selectedDates[0], selectedDates[1]);
          }
        }
      },
      chartData: {
        labels: [],
        datasets: [
          {
            data: [],
            backgroundColor: '#84D0FF',
            borderColor: 'transparent',
          },
        ],
      },

      chartDataOptions: {
        elements: {
          rectangle: {
            borderWidth: 2,
            borderSkipped: 'bottom',
          },
        },

        responsive: true,
        maintainAspectRatio: false,
        responsiveAnimationDuration: 500,
        legend: {
          display: false,
        },
        lineAt: 3, // Total Avarage line is here

        tooltips: {
          // Updated default tooltip UI
          shadowOffsetX: 1,
          shadowOffsetY: 1,
          shadowBlur: 8,
          shadowColor: 'rgba(0, 0, 0, 0.25)',
          backgroundColor: $themeColors.light,
          titleFontColor: $themeColors.dark,
          bodyFontColor: $themeColors.dark,
        },
        scales: {
          xAxes: [
            {
              display: true,
              gridLines: {
                display: false,
                color: 'rgba(200, 200, 200, 0.2)',
                zeroLineColor: 'rgba(200, 200, 200, 0.2)',
              },
              scaleLabel: {
                display: false,
              },
              ticks: {
                fontColor: '#6e6b7b',
                fontSize: 10,
                crossAlign: 'center',
              },
            },
          ],
          yAxes: [
            {
              display: true,
              gridLines: {
                color: 'rgba(200, 200, 200, 0.2)',
                zeroLineColor: 'rgba(200, 200, 200, 0.2)',
              },
              ticks: {
                min: 0,
                beginAtZero: true,
                fontColor: '#6e6b7b',
                callback: function(value) {
                  if (Number.isInteger(value)) {
                    return value;
                  }
                },
              },
            },
          ],
        },
      },
    };
  },
  mounted() {
    //console.log('mounted')
    // this.getReviewResults();
  },

  created() {
    this.setDefaultMonthRange();
  },

  watch: {
    rangeDate: {
      handler: function(val, before) {
        if (val != null) {
          if (val.includes('to')) {
            this.filterDateStart = this.rangeDate.split(' to ')[0];
            this.filterDateEnd = this.rangeDate.split(' to ')[1];
            // Avoid firing before an event is selected on first load
            if (this.selectedEvent) {
              this.selectedEvents();
            }
          }
        }
      },
    },
    StatTrigger: {
      handler: function(val, before) {
        if (val === 'ObserverStats') {
          console.log('ObserverStats');
          this.getReviewResults();
          this.resultData = {
            tableData: [],
            chartData: [],
            statistics: null,
            groupNames: [],
            chartColour: '#84D0FF',
            surveyTitle: ''
          };
        }
      },
      immediate: true,
    },
    selectedSites(newVal, oldVal){
      if(newVal !== oldVal && this.selectedEvent){
        this.selectedEvents();
      }
    }
  },
  methods: {
    setDefaultMonthRange() {
      const now = new Date();
      const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
      const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);

      const format = d => {
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${y}-${m}-${day}`;
      };

      this.filterDateStart = format(firstDay);
      this.filterDateEnd = format(lastDay);
      this.rangeDate = this.toUkRange(firstDay, lastDay);
      // Do not auto-fetch here; first fetch will occur after
      // `getReviewResults` -> `getLastEvent` resolves.
    },
    toUk(date){
      const d = String(date.getDate()).padStart(2,'0');
      const m = String(date.getMonth()+1).padStart(2,'0');
      const y = date.getFullYear();
      return `${d}/${m}/${y}`;
    },
    toUkRange(start,end){
      return `${this.toUk(start)} to ${this.toUk(end)}`;
    },
    applySelectedDates(start,end){
      const iso = d=> `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
      this.filterDateStart = iso(start);
      this.filterDateEnd = iso(end);
      this.rangeDate = this.toUkRange(start,end);
      this.selectedEvents();
    },
    setRange(start, end) {
      const format = d => {
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${y}-${m}-${day}`;
      };
      this.filterDateStart = format(start);
      this.filterDateEnd = format(end);
      this.rangeDate = this.toUkRange(start,end);
      this.selectedEvents();
    },
    selectThisWeek() {
      const now = new Date();
      const dayOfWeek = (now.getDay() + 6) % 7;
      const monday = new Date(now);
      monday.setDate(now.getDate() - dayOfWeek);
      const sunday = new Date(monday);
      sunday.setDate(monday.getDate() + 6);
      this.setRange(monday, sunday);
    },
    selectThisMonth() {
      const now = new Date();
      this.setRange(new Date(now.getFullYear(), now.getMonth(), 1), new Date(now.getFullYear(), now.getMonth() + 1, 0));
    },
    selectLastMonth() {
      const now = new Date();
      this.setRange(new Date(now.getFullYear(), now.getMonth() - 1, 1), new Date(now.getFullYear(), now.getMonth(), 0));
    },
    selectNextMonth() {
      const now = new Date();
      this.setRange(new Date(now.getFullYear(), now.getMonth() + 1, 1), new Date(now.getFullYear(), now.getMonth() + 2, 0));
    },
    selectThisYear() {
      const now = new Date();
      this.setRange(new Date(now.getFullYear(), 0, 1), new Date(now.getFullYear(), 11, 31));
    },
    showArchiveRecords() {
      if (this.archive == 'Y') {
        this.archive = 'N';

        this.selectedEvents();
      } else {
        this.archive = 'Y';

        this.selectedEvents();
      }
    },

    downloadPdf() {
      this.formShow = true;
      this.download = true;
      
      // Get chart image data
      let chartImageData = null;
      try {
        // Try to get the chart canvas from the chart component
        if (this.$refs.observerChart && this.$refs.observerChart.$el) {
          const canvas = this.$refs.observerChart.$el.querySelector('canvas');
          if (canvas) {
            chartImageData = canvas.toDataURL('image/png');
          }
        }
      } catch (error) {
        console.warn('Could not capture chart image:', error);
      }

      // Format date range for display
      let datePeriod = 'All Time';
      if (this.filterDateStart && this.filterDateEnd) {
        const startDate = new Date(this.filterDateStart);
        const endDate = new Date(this.filterDateEnd);
        datePeriod = `${startDate.toDateString()} to ${endDate.toDateString()}`;
      }

      // Prepare the data from your component
      const reportData = {
        tableData: this.resultData.tableData,
        chartData: this.resultData.chartData,
        statistics: this.resultData.statistics,
        groupNames: this.resultData.groupNames,
        surveyTitle: this.resultData.surveyTitle || this.selectedEvent?.title || 'Observer Statistics Report',
        chartColour: this.resultData.chartColour,
        chartImage: chartImageData,
        datePeriod: datePeriod,
        selectedEvent: this.selectedEvent,
        archive: this.archive
      };

      // Make the API call
      axiosIns.post('reports/download-observer-breakdown-pdf', reportData, {
        responseType: 'blob'
      })
      .then(response => {
        // Create download link
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'observer-breakdown-report.pdf');
        document.body.appendChild(link);
        link.click();
        link.remove();
        
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Success',
            text: '📊 Observer Breakdown Report downloaded successfully!',
            icon: 'DownloadIcon',
            variant: 'success',
          },
        });
      })
      .catch(error => {
        console.error('PDF download error:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error',
            text: 'Failed to generate PDF report',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        });
      })
      .finally(() => {
        this.download = false;
        this.formShow = false;
      });
    },

    // Download Excel export (Observer Results Breakdown)
    downloadExcel() {
      if (!this.selectedEvent || !this.selectedEvent.id || this.download) return;
      this.formShow = true;
      this.download = true;

      const payload = {
        eventId: this.selectedEvent.id,
        archive: this.archive,
        startDate: this.filterDateStart,
        endDate: this.filterDateEnd,
        school: this.selectedSchool && this.selectedSchool !== 'All School' ? this.selectedSchool : null,
      };

      store.dispatch('report/exportObserverResultsBreakdown', payload)
        .then(response => {
          const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'observer-breakdown-report.xlsx');
          document.body.appendChild(link);
          link.click();
          link.remove();

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Excel Exported',
              text: 'Observer breakdown Excel file downloaded successfully.',
              icon: 'DownloadIcon',
              variant: 'success',
            },
          });
        })
        .catch(error => {
          console.error('Excel export error:', error);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Export Failed',
              text: 'Unable to generate Excel file. Please try again later.',
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          });
        })
        .finally(() => {
          this.download = false;
          this.formShow = false;
        });
    },

    getLastEvent() {
      this.formShow = true;
      store
        .dispatch('report/getLastEventItem', [])
        .then((res) => {
          if (res.data) {
            this.selectedEvent = res.data;
            this.selectedEvents(res.data);
          }
        })
        .catch((error) => {
          console.log(error);
          this.formShow = false;
        });
    },
    clearDate() {
      if (this.rangeDate != null && this.rangeDate != '') {
        this.filterDateStart = null;
        this.filterDateEnd = null;
        this.rangeDate = null;
        this.selectedEvents();
      }
    },
    filterBySchool() {
      this.selectedEvents(undefined);
    },
    getReviewResults() {
      this.formShow = true;

      let filter = {
        event: this.selectedEvent ? this.selectedEvent : null,
        filterDate: {
          startDate: this.filterDateStart,
          endDate: this.filterDateEnd,
        },
        archive: this.archive,
        sites: this.selectedSites && this.selectedSites.length ? this.selectedSites : null,
      };
      store
        .dispatch('report/getAllReviewResults', filter)
        .then((res) => {
          if(res.data.length > 0){

            this.summaryList = res.data[0].summary;
          this.totalRows = res.data.length;
          this.getLastEvent();
          // reset and repopulate eventTypes to avoid stale or partial options
          this.eventTypes = [];
          res.data.forEach((element) => {
            this.eventTypes.push(element.event);
          });

          this.eventTypes = _.uniqBy(this.eventTypes, function(e) {
            return e.id;
          });

          
          }
         
          this.formShow = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    selectedEvents(event) {
      if (event != undefined) {
        this.selectedSchool = null;
      }

      let filter = {
        event: event == undefined ? this.selectedEvent : event,
        filterDate: {
          startDate: this.filterDateStart,
          endDate: this.filterDateEnd,
        },
        archive: this.archive,
        school: this.selectedSchool && this.selectedSchool !== 'All School' ? this.selectedSchool : null,
        sites: this.selectedSites && this.selectedSites.length ? this.selectedSites : null,
      };
      store
        .dispatch('report/getReviewsObsWithId', filter)
        .then((res) => {
          // Handle new API response format
          if (res.data && res.data.data) {
            this.resultData = res.data.data;
            
            // Update chart data
            this.chartData.labels = [];
            this.chartData.datasets[0].data = [];
            
            if (this.resultData.chartData && this.resultData.chartData.length > 0) {
              // Generate different colors for each bar
              const generateColors = (count) => {
                const colors = [];
                const baseColors = [
                  '#84D0FF', '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', 
                  '#FFEAA7', '#DDA0DD', '#98D8C8', '#F7DC6F', '#BB8FCE',
                  '#85C1E9', '#F8C471', '#82E0AA', '#F1948A', '#85C1E9'
                ];
                
                for (let i = 0; i < count; i++) {
                  if (i < baseColors.length) {
                    colors.push(baseColors[i]);
                  } else {
                    // Generate additional colors if needed
                    const hue = (i * 137.508) % 360; // Golden angle approximation
                    colors.push(`hsl(${hue}, 70%, 65%)`);
                  }
                }
                return colors;
              };

              const barColors = generateColors(this.resultData.chartData.length);
              
              this.resultData.chartData.forEach((item, index) => {
                this.chartData.labels.push(item.reviewerName);
                this.chartData.datasets[0].data.push(item.reviewerAverage);
              });
              
              // Set different colors for each bar
              this.chartData.datasets[0].backgroundColor = barColors;
              this.chartData.datasets[0].borderColor = barColors.map(color => color);
              
              // Set line for company average using the plugin (lineAt)
              if (this.resultData.statistics) {
                this.chartDataOptions.lineAt = this.resultData.statistics.meanScore;
                this.chartData.datasets[0].totalAvarage = this.resultData.statistics.meanScore;
              }
            }
            
            this.refreshChart = !this.refreshChart;
            this.formShow = false;
          }
        })
        .catch((error) => {
          this.formShow = false;
          console.log(error);
        });
    },
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.left-align .nav-tabs .nav-link {
  justify-content: left !important;
}

.observer-stats-table {
  font-size: 0.9rem;
  
  thead th {
    background-color: #343a40 !important;
    color: white !important;
    font-weight: 600;
    border-color: #454d55 !important;
  }
  
  tbody td {
    vertical-align: middle;
    border-color: #dee2e6;
  }
  
  .font-weight-bold {
    font-weight: 600;
  }
}

.statistics-table {
  width: 100%;
  
  th {
    background-color: #343a40 !important;
    color: white !important;
    font-weight: 600;
    border: 1px solid #454d55;
    padding: 8px 12px;
  }
  
  td {
    background-color: #f8f9fa !important;
    border: 1px solid #dee2e6;
    padding: 8px 12px;
    font-weight: 600;
  }
}

.bg-success {
  background-color: #d4edda !important;
  color: #155724 !important;
}

.bg-warning {
  background-color: #fff3cd !important;
  color: #856404 !important;
}
</style>
